import React from "react"
import Navbar1 from "../../Components/Header"
import Footer1 from "../../Components/Footer1"
import Loader from "../../Components/Loader"
import ML from "../../Images/Service/machine-learning.png";
import NLP from "../../Images/Service/nlp.png";
import CV from "../../Images/Service/vision.png";
import RP from "../../Images/Service/roboticprocess.png";
import AI from "../../Images/Service/artificial-intelligence.png";
import DL from "../../Images/Service/deep-learning.png";

export const AIPage = () => {
    return (
        <>
        <Loader/>
        <div className="Servicepage">
        <Navbar1/>
        <div className="container">
        <div id="webcrumbs2">
            <div className="w-full max-w-[1280px] bg-gradient-to-br font-sans mx-auto">
                <header className="py-12 md:py-20 px-6 md:px-10 text-center relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-full bg-blue-500 opacity-5 transform -skew-y-6"></div>
                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-slate-800 relative z-10">
                        Our AI Services 
                    </h2>
                    <p className="text-justify text-lg md:text-xl max-w-4xl mx-auto relative z-10">
                    At DATADNA, we create intelligent systems that think, learn, and act. From automating business workflows to crafting personalized user experiences, our AI solutions empower your business to move faster, smarter, and more efficiently.
                    </p>
                    <div className="flex flex-col md:flex-row justify-center mt-8 md:mt-10 space-y-2 md:space-y-0">
                        <button className="bg-blue-600 text-white px-6 md:px-8 py-3 rounded-lg md:mr-4 font-medium transition-all duration-300 hover:bg-blue-700 hover:shadow-lg transform hover:-translate-y-1">
                            Get Started
                        </button>
                     
                    </div>
                    {/* Next: "Add an animated scroll indicator arrow" */}
                </header>

                <section className="py-12 md:py-16 px-6 md:px-10">
                    <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 md:mb-16 text-slate-800">
                        Why Choose Our AI Development
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                        <div className="bg-white p-6 md:p-8 rounded-xl shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-2">
                            <div className="bg-blue-100 w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mb-6">
                                <span className="material-symbols-outlined text-blue-600 text-2xl md:text-3xl">
                                    smart_toy
                                </span>
                            </div>
                            <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4 text-slate-800">
                                Enhanced Efficiency & Automation
                            </h3>
                            <p className="text-gray-600 text-justify">
                            AI automates repetitive tasks, reducing manual effort by up to 50% and allowing teams to focus on higher-value work.

                            </p>
                        </div>

                        <div className="bg-white p-6 md:p-8 rounded-xl shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-2">
                            <div className="bg-indigo-100 w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mb-6">
                                <span className="material-symbols-outlined text-indigo-600 text-2xl md:text-3xl">
                                    trending_up
                                </span>
                            </div>
                            <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4 text-slate-800">
                                Data-Driven Decision Making
                            </h3>
                            <p className="text-gray-600 text-justify">
                            AI leverages advanced analytics to process massive datasets, uncovering patterns and trends that are often missed by traditional methods.
                            </p>
                        </div>

                        <div className="bg-white p-6 md:p-8 rounded-xl shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-2">
                            <div className="bg-cyan-100 w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mb-6">
                                <span className="material-symbols-outlined text-cyan-600 text-2xl md:text-3xl">
                                    security
                                </span>
                            </div>
                            <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4 text-slate-800">
                                Personalized Customer Experiences
                            </h3>
                            <p className="text-gray-600 text-justify">
                            AI enhances customer interactions by offering personalized recommendations, dynamic content, and predictive assistance.
                            </p>
                        </div>
                    </div>
                    {/* Next: "Add a 'View all features' button" */}
                </section>

                <section className="py-12 md:py-16 px-6 md:px-10 bg-gradient-to-r from-slate-800 to-blue-900 text-white">
                    <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 md:mb-16">Our AI Offerings</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
                        <div className="relative">
                            <div className="absolute -left-3 -top-3 md:-left-4 md:-top-4 w-12 h-12 md:w-16 md:h-16 bg-blue-500 opacity-20 rounded-lg"></div>
                            <div className="relative z-10 border border-blue-400 p-6 md:p-8 rounded-lg bg-blue-900 bg-opacity-30 backdrop-blur-sm transition-all duration-300 hover:bg-opacity-50 hover:shadow-lg">
                                <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6 flex items-center">
                                    <span className="material-symbols-outlined mr-2 md:mr-3 text-blue-300">
                                        insights
                                    </span>
                                    AI-Powered Chatbots & Virtual Assistants
                                </h3>
                                <p className="text-justify mb-3">
                                Enhance customer support with 24/7 intelligent automation!
                                </p>
                                <ul className="space-y-3">
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-blue-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>NLP-based AI Chatbots</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-blue-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Multilingual support for global reach</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-blue-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Integration with WhatsApp, Facebook, and website chat</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-blue-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Lead generation & automated response handling</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="relative">
                            <div className="absolute -left-3 -top-3 md:-left-4 md:-top-4 w-12 h-12 md:w-16 md:h-16 bg-indigo-500 opacity-20 rounded-lg"></div>
                            <div className="relative z-10 border border-indigo-400 p-6 md:p-8 rounded-lg bg-indigo-900 bg-opacity-30 backdrop-blur-sm transition-all duration-300 hover:bg-opacity-50 hover:shadow-lg">
                                <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6 flex items-center">
                                    <span className="material-symbols-outlined mr-2 md:mr-3 text-indigo-300">
                                        auto_awesome
                                    </span>
                                    AI-Driven Data Analytics & Insights
                                </h3>
                                <p className="text-justify mb-3">
                                Make data-driven decisions with AI-powered analytics!
                                </p>
                                <ul className="space-y-3">
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-indigo-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Predictive analytics & forecasting</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-indigo-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Business intelligence dashboards</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-indigo-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span> AI-based sentiment analysis & customer insights</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-indigo-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Real-time data processing & visualization</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="relative">
                            <div className="absolute -left-3 -top-3 md:-left-4 md:-top-4 w-12 h-12 md:w-16 md:h-16 bg-cyan-500 opacity-20 rounded-lg"></div>
                            <div className="relative z-10 border border-cyan-400 p-6 md:p-8 rounded-lg bg-cyan-900 bg-opacity-30 backdrop-blur-sm transition-all duration-300 hover:bg-opacity-50 hover:shadow-lg">
                                <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6 flex items-center">
                                    <span className="material-symbols-outlined mr-2 md:mr-3 text-cyan-300">
                                        person_search
                                    </span>
                                    AI for Image & Video Processing
                                </h3>
                                <p className="text-justify mb-3">
                                Automate and enhance media processing with AI!
                                </p>
                                <ul className="space-y-3">
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-cyan-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>AI-based video editing & enhancement</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-cyan-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Computer vision solutions for image recognition</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-cyan-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span> Facial recognition & object detection</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-cyan-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>AI-driven content tagging & categorization</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="relative">
                            <div className="absolute -left-3 -top-3 md:-left-4 md:-top-4 w-12 h-12 md:w-16 md:h-16 bg-purple-500 opacity-20 rounded-lg"></div>
                            <div className="relative z-10 border border-purple-400 p-6 md:p-8 rounded-lg bg-purple-900 bg-opacity-30 backdrop-blur-sm transition-all duration-300 hover:bg-opacity-50 hover:shadow-lg">
                                <h3 className="text-xl md:text-2xl font-semibold mb-4 md:mb-6 flex items-center">
                                    <span className="material-symbols-outlined mr-2 md:mr-3 text-purple-300">
                                        trending_up
                                    </span>
                                    AI in Automation & Process Optimization
                                </h3>
                                <p className="text-justify mb-3">
                                Streamline operations and boost efficiency with AI!
                                </p>
                                <ul className="space-y-3">
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-purple-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Robotic Process Automation (RPA)</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-purple-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>AI-driven workflow automation</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-purple-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>Smart AI-powered decision-making engines</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="material-symbols-outlined text-purple-300 mr-2 mt-1 text-sm md:text-base">
                                            check_circle
                                        </span>
                                        <span>AI-integrated ERP & CRM solutions</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* Next: "Add a case study section with real-world examples" */}
                </section>

                <section className="py-12 md:py-16 px-6 md:px-10">
                    <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 md:mb-16 text-slate-800">
                        How AI Changes Business
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-10 md:mb-16">
                        <div className="bg-gradient-to-br from-blue-500 to-indigo-600 p-6 md:p-8 rounded-xl text-white shadow-lg transform transition-transform duration-300 hover:scale-105">
                            <h3 className="text-4xl md:text-5xl font-bold mb-2 text-center">40%</h3>
                            <p className="text-blue-100 text-base md:text-lg">
                            AI-driven businesses see a 40% boost in operational efficiency
                            </p>
                        </div>

                        <div className="bg-gradient-to-br from-indigo-500 to-purple-600 p-6 md:p-8 rounded-xl text-white shadow-lg transform transition-transform duration-300 hover:scale-105">
                            <h3 className="text-4xl md:text-5xl font-bold mb-2 text-center">90%</h3>
                            <p className="text-indigo-100 text-base md:text-lg">
                            Leading companies invest in AI to enhance customer experience
                            </p>
                        </div>

                        <div className="bg-gradient-to-br from-cyan-500 to-blue-600 p-6 md:p-8 rounded-xl text-white shadow-lg transform transition-transform duration-300 hover:scale-105">
                            <h3 className="text-4xl md:text-5xl font-bold mb-2 text-center">30%</h3>
                            <p className="text-cyan-100 text-base md:text-lg">
                            AI-powered automation reduces costs by upto
                            </p>
                        </div>
                    </div>

                    {/* <div className="bg-white p-6 md:p-10 rounded-2xl shadow-xl">
                        <h3 className="text-xl md:text-2xl font-semibold mb-6 md:mb-8 text-slate-800 text-center">
                            AI Adoption by Industry
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
                            <div className="space-y-6">
                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-medium">Healthcare</span>
                                        <span className="font-medium">76%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                                        <div className="bg-blue-600 h-2.5 rounded-full w-[76%] transition-all duration-1000"></div>
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-medium">Financial Services</span>
                                        <span className="font-medium">82%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                                        <div className="bg-blue-600 h-2.5 rounded-full w-[82%] transition-all duration-1000"></div>
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-medium">Retail</span>
                                        <span className="font-medium">68%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                                        <div className="bg-blue-600 h-2.5 rounded-full w-[68%] transition-all duration-1000"></div>
                                    </div>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-medium">Manufacturing</span>
                                        <span className="font-medium">71%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                                        <div className="bg-blue-600 h-2.5 rounded-full w-[71%] transition-all duration-1000"></div>
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-medium">Transportation</span>
                                        <span className="font-medium">64%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                                        <div className="bg-blue-600 h-2.5 rounded-full w-[64%] transition-all duration-1000"></div>
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-medium">Energy & Utilities</span>
                                        <span className="font-medium">59%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                                        <div className="bg-blue-600 h-2.5 rounded-full w-[59%] transition-all duration-1000"></div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>*/}
                    
                </section>
                <section className="py-12 md:py-16 px-4 md:px-6">
                    <div className="text-center mb-8 md:mb-12">
                        <h2 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4">AI Technologies We Use</h2>
                        <p className="max-w-4xl mx-auto text-justify">
                        AI revolutionizes business processes by automating repetitive tasks, delivering data-driven insights, and personalizing customer interactions. Companies implementing AI experience 20-30% improved efficiency and 25-35% faster decision-making. AI-driven innovation positions businesses as market leaders, driving higher customer satisfaction and long-term profitability.
                        </p>
                    </div>

                    <div className="grid grid-cols-1  md:grid-cols-3 gap-6 md:gap-8">
                        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:bg-blue-50 flex flex-col items-center">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <i className="fa-brands text-5xl text-blue-500"><img src={ML} alt="Machine Learning"></img></i>
                            </div>
                            <h3 className="font-semibold text-lg mb-2">Machine Learning (ML)</h3>
                            <p className="text-gray-600 text-sm text-justify">
                            Machine Learning allows systems to automatically learn and improve from experience without being explicitly programmed.
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:bg-green-50 flex flex-col items-center">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <i className="fa-brands  text-5xl text-green-600"><img src={NLP} alt="Natural Language Processing"></img></i>
                            </div>
                            <h3 className="font-semibold text-lg mb-2">Natural Language Processing (NLP)</h3>
                            <p className="text-gray-600 text-sm text-justify">
                            NLP enables machines to understand, interpret, and respond to human language in a meaningful way.
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:bg-green-50 flex flex-col items-center">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                {/* <svg className="w-12 h-12" viewBox="0 0 32 32" fill="none">
                                    <path
                                        d="M15.9.087l.854 1.604c.192.296.4.558.645.802.715.715 1.394 1.464 2.004 2.266 1.447 1.9 2.423 4.01 3.12 6.292.418 1.394.645 2.824.662 4.27.07 4.323-1.412 8.035-4.4 11.12-.488.488-1.01.94-1.57 1.342-.296 0-.436-.227-.558-.436-.227-.383-.366-.802-.436-1.222-.105-.614-.105-1.227-.105-1.84v-.305c-.105.01-.227-.105-.227-.197-.105-.21-.21-.436-.296-.645-.21-.524-.797-.873-1.342-.767-.488.105-.884.505-.884 1.01v.105c-.314.994-.645 1.976-.973 2.96-.14.436-.436.61-.858.61-.42 0-.73-.227-.806-.645-.192-.872-.27-1.734-.453-2.597-.183-.872-.627-1.693-1.287-2.337-.767-.767-1.538-1.464-2.423-2.023-.094-.105-.192-.227-.296-.323-.017-.052-.04-.1-.07-.149L.254 23.172l4.287-2.038c.365-.183.635-.557.635-.975 0-.423-.27-.79-.635-.976l-4.287-2.026 7.79-13.517s.096.017.105.175c.096.923.157 1.828.4 2.738.165.548.358 1.08.575 1.6.323.766.732 1.495 1.18 2.197.58.94 1.278 1.81 2.08 2.6 1.393 1.436 2.886 2.744 4.394 4.058.262.21.558.36.875.36.318 0 .61-.14.853-.36.314-.227.61-.488.886-.766.192-.21.453-.313.732-.313.27 0 .522.105.732.313.42.409.314 1.074-.21 1.39-1.064.664-1.972 1.498-2.675 2.496-.122.17-.244.348-.33.54v.017c-.052.122-.087.244-.096.375-.017.174 0 .366.052.54.174.557.418 1.08.732 1.583.49.766 1.064 1.466 1.55 2.215.142.244.262.505.366.775.175.558.175 1.147.105 1.734-.07.558-.2 1.1-.453 1.584-.105.244-.288.47-.488.662-.244.21-.54.296-.858.296-1.25-.105-2.337-.73-3.382-1.476-1.398-.996-2.735-2.09-3.977-3.27-1.674-1.583-3.254-3.2-4.912-4.747-.21-.21-.488-.21-.7 0-.57.583-1.154 1.156-1.763 1.704-.68.61-1.308 1.29-1.9 2.007-.453.558-.835 1.154-1.113 1.812-.244.558-.384 1.143-.41 1.74 0 .453.105.9.314 1.32.418.83 1.006 1.517 1.62 2.198.45.475.924.93 1.42 1.36l-.013.012 4.55 4.597-2.586 1.9c-.226.21-.436.418-.548.697-.14.314-.105.66.07.96.278.557.766 1.01 1.358 1.204.106 0 .192.106.192.214v2.495s-8.105-5.02-13.285-15.065C.08 16.87-.04 16.362.014 15.832c.07-.558.297-1.08.61-1.518.314-.47.697-.83 1.115-1.126.875-.696 1.743-1.39 2.624-2.09.2-.17.453-.296.696-.296s.497.122.696.296c.78.697 1.516 1.427 2.302 2.09 1.195 1.01 2.42 1.95 3.842 2.586.488.226 1.006.174 1.385-.244.192-.213.297-.493.297-.793 0-.366-.174-.696-.47-.9-.516-.364-1.108-.66-1.673-.935-.153-.07-.297-.174-.47-.226-.245-.063-.508-.063-.764 0-.105-.022-.21-.07-.314-.106-.61-.296-1.204-.662-1.743-1.08-1.042-.823-1.933-1.808-2.624-2.925-.453-.767-.767-1.586-1.115-2.388-.035-.105-.07-.227-.088-.314z"
                                        fill="#10AA50"
                                    />
                                </svg> */}
                                <i className="fa-brands text-5xl text-blue-500"><img src={CV} alt="Computer Vision"></img></i>
                            </div>
                            <h3 className="font-semibold text-lg mb-2">Computer Vision (CV)</h3>
                            <p className="text-gray-600 text-sm text-justify">Computer Vision allows machines to interpret and process visual data from images and videos.</p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:bg-red-50 flex flex-col items-center">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <i className="fa-brands text-5xl text-red-600"><img src={RP} alt="Robotic Process Automation"></img></i>
                            </div>
                            <h3 className="font-semibold text-lg mb-2">Robotic Process Automation (RPA)</h3>
                            <p className="text-gray-600 text-sm text-justify">
                            RPA automates repetitive, rule-based tasks by mimicking human interactions with digital systems.
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:bg-blue-50 flex flex-col items-center">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                                <i className="fa-brands text-5xl text-orange-500"><img src={AI} alt="Generative AI"></img></i>
                            </div>
                            <h3 className="font-semibold text-lg mb-2">Generative AI (GenAI)</h3>
                            <p className="text-gray-600 text-sm text-justify">
                            Generative AI models (such as GPT and DALL-E) create text, images, videos, and other content based on input prompts.
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:bg-purple-50 flex flex-col items-center">
                            <div className="w-16 h-16 mb-4 flex items-center justify-center">
                            <i className="fa-brands text-5xl text-orange-500"><img src={DL} alt="Deep Learning"></img></i>
                            </div>
                            <h3 className="font-semibold text-lg mb-2">Deep Learning (DL)</h3>
                            <p className="text-gray-600 text-sm text-justify">
                            Deep Learning, a subset of ML, uses artificial neural networks to simulate human-like learning.
                            </p>
                        </div>
                    </div>
                </section>


                <section className="py-12 md:py-16 px-6 md:px-10">
                    <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-10 text-slate-800">
                        Ready to Transform Your Business?
                    </h2>
                    <p className=" text-base md:text-lg max-w-4xl mx-auto mb-8 md:mb-10 text-justify">
                     AI transforms business operations by enhancing decision-making, automating workflows, and predicting customer behavior.Businesses utilizing AI see a 40% improvement in operational efficiency and gain a competitive advantage through personalized customer experiences.
                    </p>
                    <div className="flex justify-center">
                        <button className="bg-blue-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-lg font-medium text-base md:text-lg transition-all duration-300 hover:bg-blue-700 hover:shadow-xl transform hover:-translate-y-1">
                            Schedule a Consultation
                        </button>
                    </div>
                    {/* Next: "Add a newsletter signup form with email validation" */}
                </section>
            </div>
        </div>
        </div>
        <Footer1/>
        </div>
        </>
    )
}